<div class="wrapper-list-stores">
  <div class="section-title">
    <div class="row align-items-center">
      <div class="col-sm-6 col-12">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Pages" | translate }}</div>
        </div>
      </div>
      <div class="col-sm-6 col-12 text-sm-right text-left mt-2 mt-sm-0">
        <div class="d-inline-flex align-items-center flex-wrap topbar-actions">
          <button
            class="btn btn-outline-primary mr-2 ui-classic-only"
            routerLink="/dashboard/landing-page-report"
          >
            <i class="fi fi-rr-chart-pie-alt mr-1"></i>
            <span>{{ "Performance Report" | translate }}</span>
          </button>
          <button class="btn btn-primary" routerLink="/dashboard/page/create">
            {{ "Create page" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="checkout-toolbar mb-4">
    <div class="filter-options">
      <!-- Sort Filter Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-filter"
          [class.active]="defaultSort"
          id="dropdownSort"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-sort-alt mr-1"></i>
          <span>{{ getSelectedSort(defaultSort) | translate }}</span>
        </button>
        <div
          ngbDropdownMenu
          aria-labelledby="dropdownSort"
          class="custom-dropdown shadow-md"
          style="min-width: 180px;"
        >
          <button
            ngbDropdownItem
            *ngFor="let s of sortType"
            (click)="sortByType(s)"
            class="py-2"
          >
            <span>{{ s.type | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Search, and (glass theme) the performance report button on its right -->
    <div class="toolbar-end d-flex align-items-center gap-2">
      <div class="search-box">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filteredString"
          (input)="updateFilter($event)"
          placeholder="{{ 'Search by Page Name' | translate }}..."
        />
        <i class="fi fi-rr-search search-icon"></i>
        <i class="fas fa-times clear-icon" *ngIf="filteredString" (click)="clearPageSearch()"></i>
      </div>
      <button
        class="btn btn-outline-primary ui-glass-only toolbar-report-btn"
        routerLink="/dashboard/landing-page-report"
      >
        <i class="fi fi-rr-chart-pie-alt mr-1"></i>
        <span>{{ "Performance Report" | translate }}</span>
      </button>
    </div>
  </div>

  <div class="section-main">
    <div
      class="col-lg-12 col-sm-12 mt-5"
      *ngIf="getDisplayedPageList()?.length == 0 && !loading"
    >
      <div class="col-lg-12 col-sm-12">
        <div>
          <div class="p-10 text-center no-records">
            {{ "No Record found" | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="loading-spinner col-12 mt-5 pb-3" *ngIf="loading">
      <mat-spinner class="mx-auto" [diameter]="50"></mat-spinner>
    </div>
    <div class="row order-card my-2" *ngIf="pageList?.length != 0 && !loading">
      <div class="col-lg-12 col-sm-12">
        <div
          class="card my-2"
          style="width: 100% !important"
          *ngFor="let data of getDisplayedPageList(); let i = index"
        >
          <div class="row align-items-center">
            <!-- title & editor indicator -->
            <div class="col-lg-5 col-md-4 col-12">
              <div class="list-info-group flex flex-auto">
                <div class="text-left overflow-hidden w-100">
                  <p class="value-text font-weight-bold mb-0 text-truncate" [title]="data?.page_title">
                    {{ data?.page_title }}
                  </p>
                  <div class="mt-1 d-inline-flex">
                    <span
                      class="editor-badge"
                      [ngClass]="getEditorInfo(data).class"
                      #tooltip="matTooltip"
                      [matTooltip]="('Built with ' | translate) + (getEditorInfo(data).label | translate)"
                      matTooltipPosition="above"
                      matTooltipHideDelay="100"
                    >
                      <i [class]="getEditorInfo(data).icon"></i>
                      <span>{{ getEditorInfo(data).label | translate }}</span>
                    </span>
                    <span
                      class="editor-badge badge-page-home ml-1"
                      *ngIf="isHomePageRow(data)"
                      #tooltip="matTooltip"
                      [matTooltip]="'This page is shown as your storefront home page' | translate"
                      matTooltipPosition="above"
                      matTooltipHideDelay="100"
                    >
                      <i class="fi fi-rr-home"></i>
                      <span>{{ "Home Page" | translate }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- datetime -->
            <div class="col-lg-3 col-md-3 col-12 text-md-center text-left my-2 my-md-0">
              <div>
                <p
                  class="mb-0 text-sm"
                  #tooltip="matTooltip"
                  matTooltip="Created on {{
                    data.created_at | date : 'medium'
                  }}"
                  matTooltipPosition="above"
                  matTooltipHideDelay="100"
                >
                  {{ data.created_at | timeago : true }}
                </p>
                <p
                  *ngIf="data.updated_at !== data.created_at"
                  #tooltip="matTooltip"
                  matTooltip="Edited on {{ data.updated_at | date : 'medium' }}"
                  matTooltipPosition="above"
                  matTooltipHideDelay="100"
                  class="text-slate-400 text-xs mt-1 mb-0"
                >
                  {{ "Edited" | translate }}
                  {{ data.updated_at | timeago : true }}
                </p>
              </div>
            </div>
            <!-- actions -->
            <div class="col-lg-4 col-md-5 col-12">
              <div class="page-action-group">
                <button
                  type="button"
                  class="btn-action btn-action-view"
                  (click)="showLinks(data)"
                >
                  <i class="fi fi-rr-link-alt"></i>
                  <span>{{ "View links" | translate }}</span>
                </button>

                <button
                  type="button"
                  class="btn-action btn-action-edit"
                  (click)="edit(data.store_page_id)"
                >
                  <i class="fi fi-rr-edit"></i>
                  <span>{{ "Edit" | translate }}</span>
                </button>

                <button
                  type="button"
                  class="btn-action-icon btn-action-report"
                  (click)="viewReport(data)"
                  #tooltip="matTooltip"
                  matTooltip="{{ 'Performance Report' | translate }}"
                  matTooltipPosition="above"
                  matTooltipHideDelay="100"
                  aria-label="Performance Report"
                >
                  <i class="fi fi-rr-chart-pie-alt"></i>
                </button>

                <button
                  type="button"
                  class="btn-action-icon btn-action-duplicate"
                  (click)="tryDuplicate(duplicate, data)"
                  #tooltip="matTooltip"
                  matTooltip="{{ 'Duplicate' | translate }}"
                  matTooltipPosition="above"
                  matTooltipHideDelay="100"
                  aria-label="Duplicate"
                >
                  <i class="fi fi-rr-copy-alt"></i>
                </button>

                <button
                  type="button"
                  class="btn-action-icon btn-action-delete"
                  (click)="open(content, data.store_page_id)"
                  #tooltip="matTooltip"
                  matTooltip="{{ 'Delete' | translate }}"
                  matTooltipPosition="above"
                  matTooltipHideDelay="100"
                  aria-label="Delete"
                >
                  <i class="fi fi-rr-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="pagination-container row align-items-center px-4 py-3"
          *ngIf="displayedPageList?.length != 0"
        >
          <div class="col-md-6 col-12 d-flex justify-content-md-start justify-content-center mb-2 mb-md-0">
            <ngb-pagination
              [collectionSize]="displayedPageList.length"
              [(page)]="page"
              [pageSize]="selectedPage"
              aria-label="Default pagination"
              (pageChange)="changePage($event)"
              [ellipses]="false"
              [rotate]="true"
              [maxSize]="5"
            ></ngb-pagination>
          </div>
          <div class="col-md-6 col-12 d-flex justify-content-md-end justify-content-center">
            <div class="pagination-info text-center text-md-right">
              {{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }}
              <b>{{ pageList.length }}</b>
            </div>
          </div>
        </div>
      </div>

      <ng-template #linkList let-modal>
        <div class="links-modal-container">
          <div class="modal-header d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="modal-header-icon mr-3">
                <i class="fi fi-rr-link-alt"></i>
              </div>
              <div>
                <h5 class="modal-title mb-0 font-weight-bold">
                  {{ "Page Links" | translate }}
                </h5>
                <div class="d-flex align-items-center flex-wrap gap-2 mt-1">
                  <p class="text-muted text-xs mb-0 font-weight-500" *ngIf="targetPageData?.page_title">
                    {{ targetPageData?.page_title }}
                  </p>
                  <span
                    class="editor-badge"
                    [ngClass]="getEditorInfo(targetPageData).class"
                    #tooltip="matTooltip"
                    [matTooltip]="('Built with ' | translate) + (getEditorInfo(targetPageData).label | translate)"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i [class]="getEditorInfo(targetPageData).icon"></i>
                    <span>{{ getEditorInfo(targetPageData).label | translate }}</span>
                  </span>
                </div>
              </div>
            </div>
            <button
              type="button"
              class="btn-close-modal"
              aria-label="Close"
              (click)="modal.dismiss('Cross click')"
            >
              <i class="fi fi-rr-cross-small"></i>
            </button>
          </div>

          <div class="modal-body p-3 p-md-4">
            <div class="loading-spinner py-5 text-center" *ngIf="loading">
              <mat-spinner class="mx-auto" [diameter]="42"></mat-spinner>
            </div>

            <!-- Empty State -->
            <div
              class="text-center py-5 empty-links"
              *ngIf="(!activeDomainList || activeDomainList.length === 0) && !loading"
            >
              <div class="empty-icon mb-3">
                <i class="fi fi-rr-link-slash"></i>
              </div>
              <h6 class="font-weight-bold text-secondary">{{ "No active domains found" | translate }}</h6>
              <p class="text-muted text-xs mb-0">
                {{ "Please configure a domain to preview or share this landing page." | translate }}
              </p>
            </div>

            <!-- Links Cards List -->
            <div
              class="link-list-wrapper"
              *ngIf="activeDomainList?.length > 0 && !loading"
            >
              <div
                class="link-item-card"
                *ngFor="let baseUrl of activeDomainList; let i = index"
              >
                <div class="link-item-main">
                  <div class="d-flex align-items-center mb-2 flex-wrap gap-2">
                    <span class="domain-badge" [class.primary]="i === 0">
                      <i class="fi" [ngClass]="i === 0 ? 'fi-rr-home' : 'fi-rr-globe'"></i>
                      <span>{{ (i === 0 ? "Primary Domain" : "Custom Domain") | translate }}</span>
                    </span>
                    <span
                      class="visibility-badge"
                      [class.published]="+targetPageData?.visibility === 1"
                    >
                      <i
                        class="fi"
                        [ngClass]="+targetPageData?.visibility === 1 ? 'fi-rr-check' : 'fi-rr-eye-crossed'"
                      ></i>
                      <span>{{ (+targetPageData?.visibility === 1 ? "Published" : "Hidden") | translate }}</span>
                    </span>
                  </div>

                  <div class="url-container">
                    <a
                      [href]="publicPageUrl(baseUrl, targetPageData)"
                      target="_blank"
                      class="url-text"
                      #tooltip="matTooltip"
                      matTooltip="{{ 'Click to open in new tab' | translate }}"
                      matTooltipPosition="above"
                      matTooltipHideDelay="100"
                    >
                      <span class="url-string">{{ publicPageUrl(baseUrl, targetPageData) }}</span>
                      <i class="fi fi-rr-arrow-small-right ml-1"></i>
                    </a>
                  </div>

                  <div class="url-meta text-xs text-muted mt-2 d-flex align-items-center flex-wrap gap-2">
                    <span>
                      {{ "Created" | translate }}: {{ targetPageData?.created_at | timeago : true }}
                    </span>
                    <span *ngIf="targetPageData?.updated_at && targetPageData?.updated_at !== targetPageData?.created_at">
                      • {{ "Edited" | translate }}: {{ targetPageData?.updated_at | timeago : true }}
                    </span>
                  </div>
                </div>

                <div class="link-item-actions">
                  <button
                    type="button"
                    class="btn-link-action btn-copy"
                    (click)="
                      utils.copyToClipboard(
                        publicPageUrl(baseUrl, targetPageData),
                        'Page URL'
                      )
                    "
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Copy URL to clipboard' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i class="las la-copy"></i>
                    <span>{{ "Copy" | translate }}</span>
                  </button>

                  <button
                    type="button"
                    class="btn-link-action btn-preview"
                    (click)="preview(baseUrl, targetPageData)"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Preview page in browser' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i class="fi fi-rr-eye"></i>
                    <span>{{ "Preview" | translate }}</span>
                  </button>

                  <button
                    type="button"
                    class="btn-link-action btn-analytics"
                    (click)="modal.dismiss(); viewReport(targetPageData)"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'View performance metrics for this page' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i class="fi fi-rr-chart-pie-alt"></i>
                    <span>{{ "Report" | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer d-flex justify-content-between align-items-center p-3">
            <div class="d-flex align-items-center">
              <button
                type="button"
                class="btn btn-outline-primary text-xs d-inline-flex align-items-center py-2 px-3 mr-3"
                (click)="modal.dismiss(); viewReport(targetPageData)"
              >
                <i class="fi fi-rr-chart-pie-alt mr-1"></i>
                <span>{{ "View Performance Report" | translate }}</span>
              </button>
              <div class="text-xs text-muted d-none d-sm-inline" *ngIf="activeDomainList?.length > 0">
                <i class="fi fi-rr-info mr-1"></i>
                {{ activeDomainList.length }} {{ "active domain link(s)" | translate }}
              </div>
            </div>
            <button
              type="button"
              class="btn btn-secondary px-4 py-2 text-sm rounded-lg"
              (click)="modal.dismiss('Cross click')"
            >
              {{ "Close" | translate }}
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template #content let-modal>
        <div class="modal-duplicate-header">
          <h4 class="modal-title" id="modal-basic-title">
            {{ ("Delete " | translate) + pageName + "?" }}
          </h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-duplicate-body">
          <div class="text-subtitle mb-2">
            {{ "Delete " | translate }} <b>'{{ pageName }}'</b
            >{{ "? This can't be undone." | translate }}
          </div>
          <div class="text-subtitle text-danger mb-2" *ngIf="deletingHomePage">
            {{
              "This is your home page. Deleting it puts the default storefront home page back."
                | translate
            }}
          </div>
        </div>
        <div class="modal-duplicate-footer">
          <button
            type="button"
            class="btn-outline-cancel mr-2"
            (click)="modal.close('Save click')"
          >
            {{ "Cancel" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-danger"
            (click)="modal.close('delete')"
          >
            {{ "Delete" | translate }}
          </button>
        </div>
      </ng-template>

      <ng-template #duplicate let-modal>
        <div class="modal-duplicate-header">
          <h4 class="modal-title" id="modal-basic-title">
            {{ "Duplicate this page?" | translate }}
          </h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-duplicate-body">
          <div class="text-subtitle mb-2">
            {{ "Provide a name for your new page" | translate }}
          </div>
          <input type="text" [(ngModel)]="duplicatePageName" />
        </div>
        <div class="modal-duplicate-footer">
          <button
            type="button"
            class="btn-outline-cancel mr-2"
            (click)="modal.close('cancel')"
          >
            {{ "Cancel" | translate }}
          </button>
          <button
            type="button"
            class="btn-outline-duplicate"
            (click)="modal.close('submit')"
          >
            {{ "Duplicate" | translate }}
          </button>
        </div>
      </ng-template>

      <ng-template #success let-modal>
        <div class="modal-body text-center">
          <div class="row" align="center">
            <div class="col pt-4 pt-lg-0">
              <h4>{{ "Successfully Update" | translate }}</h4>
            </div>
          </div>
          <button
            class="btn btn-primary"
            type="button"
            name="button"
            (click)="modal.close('Send click')"
          >
            {{ "Close" | translate }}
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
